/**
 *
 * @param record
 * @returns {{totalPrice: number, basePrice: number, selectedModsPrice: number}|{selectedMods: *[][], totalPrice: *, selectedVariant: (T|*), basePrice: *, selectedModsPrice: *}}
 */
export const getPriceWithMods = (record) => {

    if (!record) {
        return {
            basePrice: 0,
            selectedModsPrice: 0,
            totalPrice: 0,
        };
    }

    let selectedVariantIdx = (record?.prices || []).findIndex(x => x?.selected);

    if (selectedVariantIdx === -1) {
        selectedVariantIdx = 0;
    }

    const selectedVariant = record.prices[selectedVariantIdx];
    const selectedMods = (record?.mods || []).map(m => (m.options || []).filter(o => o?.selected)).filter(x => x.length !== 0);

    const basePrice = selectedVariant?.price;
    const selectedModsPrice = selectedMods.map(x => x.reduce((a,b) => a + (b.priceMod || 0), 0)).filter(x => x !== 0).reduce( (a,b) => a + b, 0);

    const totalPrice = basePrice + (selectedModsPrice || 0);

    return {
        selectedVariant,
        selectedMods,
        selectedVariantIdx,
        basePrice,
        selectedModsPrice,
        totalPrice: totalPrice >= 0 ? totalPrice : 0 // Dd not allow negative totals
    };
}
